export default __webpack_public_path__ + "static/media/entregue_marker.ddb00c31.svg";